/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button } from "@nordcloud/gnui";

function PopoverButton() {
  return (
    <Button severity="low" icon="menu" size="md" title="popover-menu-button" />
  );
}

export { PopoverButton };
